import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {v4 as uuidv4} from "uuid";
import md5 from 'js-md5'
import moment from 'moment'
import _ from "underscore";
import jquery from "jquery";
import util from "@/utils/util";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/normal.scss"
import './directive/drag'
import "./directive/tracking"
import trackConfig from "@/utils/trackConfig";

import "@/assets/iconfont/iconfont.css";

Vue.config.productionTip = false
Vue.prototype.$_ = _;
Vue.prototype.$uuid = uuidv4;
Vue.prototype.$md5 = md5;
Vue.prototype.$moment = moment;
Vue.prototype.$util = util;
Vue.prototype.$Jquery = jquery;
Vue.prototype.$trackConfig = trackConfig;
Vue.use(Element, {
  size: "small"
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

